<template>
  <b-card-text class="mb-3">
    <b-card-text>
      Do Twojej dyspozycji oddajemy przygotowane przez naszych ekspertów
      multimedialne szkolenie: „<strong
        >Akademia SKP<sup>®</sup> - kurs obsługi programu SKP<sup
          >®</sup
        ></strong
      >”.
    </b-card-text>

    <b-card-text>
      Pracujesz w SKP<sup>®</sup> już od pewnego czasu? To szkolenie jest
      również dla Ciebie!
    </b-card-text>

    <b-card-text>
      Dzięki szkoleniu usystematyzujesz i pogłębisz swoją wiedzę z zakresu
      korzystania z programu. Nasi eksperci przygotowali mnóstwo praktycznych
      podpowiedzi, jak płynnie poruszać się po SKP<sup>®</sup>, zoptymalizować
      prace z wykorzystaniem programu tak, aby zaoszczędzić jak najwięcej czasu.
      Co więcej, zobaczysz, jak stosować ułatwienia, jakie oferuje program, np.
    </b-card-text>

    <b-card-text class="color-grey font-italic">
      „Chcesz mieć pewność, że dwa razy nie zaksięgujesz tego samego dokumentu?
      Zaznacz w opcjach Księgowania: (KSIEGOWANIE > OPCJE) KONTROLĘ UNIKALNOŚCI
      DOKUMENTÓW. Program porówna czy nie użyłeś już wcześniej tego samego
      kontrahenta i numeru dokumentu jednocześnie. Jeśli tak się stało,
      poinformuje Cię o tym fakcie stosownym komunikatem”.
    </b-card-text>

    <b-card-text>
      Więcej takich i podobnych praktycznych porad znajdziesz w kolejnych
      lekcjach Kursu. Więcej informacji na temat Kursu znajdziesz na stronie:
      <a
        href="https://www.ksiega-podatkowa.pl/kurs-obslugi-programu-skp/o-kursie"
        target="_blank"
        >Certyfikowany Kurs Obsługi SKP<sup>®</sup> ></a
      >
    </b-card-text>

    <b-card-text>
      <h5 class="my-2 font-weight-bold info-text">
        Jak zamówić kurs w promocyjnej cenie 79.00 zł ?
      </h5>
      <ul class="greenBig">
        <li>Wejdź do zakładki <strong>Zamówienie</strong></li>
        <li>
          Na liście produktów zaznacz pozycję:
          <strong>Certyfikowany Kurs Obsługi SKP<sup>®</sup></strong>
        </li>
        <li>
          Następnie w celu złożenia zamówienia
          <strong>przejdź wszystkie kroki formularza</strong>
        </li>
        <li>
          Po złożeniu zamówienia w tej zakładce otrzymasz dostęp do wszystkich
          modułów kursu
        </li>
      </ul>
    </b-card-text>

    <b-card-text class="text-danger">
      Uwaga! Promocja ograniczona czasowo, ważna
      <strong>do 31.12.{{ currentYear }} r</strong>.
    </b-card-text>
  </b-card-text>
</template>

<script>
export default {
  name: 'CourseInfo',
  props: {
    styles: {},
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped></style>
